module.exports = __webpack_public_path__ + "img/24600.59e130ed.jpg";